import DepsService from 'services/dependencies';
import roles from 'app/validators/roles';
import pick from 'lodash/pick';

const getSearchUrl = () => DepsService.rest.retailerGroup.search.url;
const getByUserUrl = () => DepsService.rest.retailerGroup.byUser.url;
const maxPageSize = 500;

export function getRetailerGroups(queryParameters = {}) {
  const { role, id } = DepsService.$ngRedux.getState().session;
  const parameters = { ...queryParameters, statusCode: 1 };
  return roles.ADMIN_ROLES.includes(role)
    ? DepsService.restSrv.list(undefined, getSearchUrl(), parameters)
    : DepsService.restSrv.list(undefined, getByUserUrl(), {}, { id }).then(
      retailerGroups => getRetailerGroupsSpecified(retailerGroups, parameters)
    );
}

export function getOwnerRetailerGroups(queryParameters = {}) {
  const { role, ownerRetailerGroups } = DepsService.$ngRedux.getState().session;
  const parameters = { ...queryParameters, statusCode: 1 };
  return roles.ADMIN_ROLES.includes(role)
    ? DepsService.restSrv.list(undefined, getSearchUrl(), parameters)
    : getRetailerGroupsSpecified(ownerRetailerGroups, parameters);
}

export function getRetailerGroup(id) {
  return DepsService.restSrv.get(undefined, DepsService.rest.retailerGroup.get.url, undefined, { id });
}

export function getRetailerGroupMembers(id, parameters) {
  return DepsService.restSrv.get(undefined, DepsService.rest.retailerGroup.members.url, parameters, { id });
}

export function getOwnerRetailerGroupIds(ownerId) {
  return DepsService.restSrv.get(undefined, DepsService.rest.retailerGroup.ids.forOwner.url, undefined, { ownerId });
}

export function getRetailerGroupsSpecified(groupIds = [], queryParameters = {}) {
  return DepsService.restSrv.create(undefined, getSearchUrl(), { groupIds }, {
    'page-size': maxPageSize,
    ...queryParameters,
  });
}

export function createRetailerGroup(retailerGroup) {
  return DepsService.restSrv.create(undefined, DepsService.rest.retailerGroup.create.url, retailerGroup);
}

export function updateRetailerGroup(retailerGroup) {
  const data = pick(retailerGroup, [  // todo extract to separate function
    'reportingGroupOid', 'name', 'description',
    'groupType', 'groupSubType', 'ownerId',
    'fiscalWeekStartDay', 'fiscalYearStartMonth',
    'retailerIds', 'userIds'
  ]);
  return DepsService.restSrv.update(undefined, DepsService.rest.retailerGroup.update.url, data, {
    id: retailerGroup.reportingGroupOid
  });
}

export function deleteRetailerGroup(retailerGroup) {
  return DepsService.restSrv.update(undefined, DepsService.rest.retailerGroup.delete.url, retailerGroup, {
    id: retailerGroup.reportingGroupOid
  });
}

export function getRetailersValidated(groupType, ownerId, retailerIds) {
  const requestBody = {
    groupType,
    ownerId,
    retailers: retailerIds.map((retailerId) => ({ retailerId }))
  };
  return DepsService.restSrv.create(undefined, DepsService.rest.retailerGroup.validateRetailers.url, requestBody);
}



// WEBPACK FOOTER //
// ./src/modules/retailer-groups/resources/retailer-groups-api.js